var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overlay",style:(_vm.marginLeftStyle)}),_vm._v(" "),_vm._l((_vm.cols - 1),function(n){return _c('div',{key:n,staticClass:"overlay",style:(_vm.gutterStyle(n))})}),_vm._v(" "),_c('div',{staticClass:"overlay",style:(_vm.marginRightStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }